import React from 'react';

const Pagination = ({
  viewMode,
  setViewMode,
  filteredProducts,
  products,
  itemsPerPage,
  setItemsPerPage,
  sortBy,
  setSortBy,
  currentPage,
  setCurrentPage,
  totalPages
}) => {
  
  // Generate page numbers for pagination
  const getPageNumbers = () => {
    const pageNumbers = [];
    const maxVisiblePages = 5;
    
    if (totalPages <= maxVisiblePages) {
      for (let i = 1; i <= totalPages; i++) {
        pageNumbers.push(i);
      }
    } else {
      const start = Math.max(1, currentPage - Math.floor(maxVisiblePages / 2));
      const end = Math.min(totalPages, start + maxVisiblePages - 1);
      
      for (let i = start; i <= end; i++) {
        pageNumbers.push(i);
      }
    }
    
    return pageNumbers;
  };
  
  // Handle page change
  const handlePageChange = (page) => {
    if (page >= 1 && page <= totalPages) {
      setCurrentPage(page);
    }
  };
  
  return (
    <div className="shop-page-meta">
      {/* <div className="shop-grid-menu">
        <ul>
          <li className={viewMode === 'grid' ? 'active' : ''}>
            <a href="#" onClick={(e) => { e.preventDefault(); setViewMode('grid'); }}>
              <i className="fas fa-th" />
            </a>
          </li>
          <li className={viewMode === 'list' ? 'active' : ''}>
            <a href="#" onClick={(e) => { e.preventDefault(); setViewMode('list'); }}>
              <i className="fas fa-list" />
            </a>
          </li>
        </ul>
      </div> */}
      <div className="shop-showing-result">
        <p>
          Showing {filteredProducts.length} of {products.length} items
        </p>
      </div>
      <div className="shop-show-list">
        <form>
          <label htmlFor="bottomShow">Show</label>
          <select 
            id="bottomShow" 
            className="selected"
            value={itemsPerPage}
            onChange={(e) => setItemsPerPage(parseInt(e.target.value))}
          >
            <option value="9">09</option>
            <option value="15">15</option>
            <option value="21">21</option>
          </select>
        </form>
      </div>
      <div className="shop-pagination">
        <ul>
          {/* Previous button */}
          <li className={currentPage === 1 ? 'disabled' : ''}>
            <a 
              href="#" 
              onClick={(e) => { 
                e.preventDefault(); 
                if (currentPage > 1) handlePageChange(currentPage - 1); 
              }}
            >
              <i className="fas fa-angle-left" />
            </a>
          </li>
          
          {/* Page numbers */}
          {getPageNumbers().map(page => (
            <li key={page} className={currentPage === page ? 'active' : ''}>
              <a 
                href="#" 
                onClick={(e) => { 
                  e.preventDefault(); 
                  handlePageChange(page); 
                }}
              >
                {page}
              </a>
            </li>
          ))}
          
          {/* Next button */}
          <li className={currentPage === totalPages ? 'disabled' : ''}>
            <a 
              href="#" 
              onClick={(e) => { 
                e.preventDefault(); 
                if (currentPage < totalPages) handlePageChange(currentPage + 1); 
              }}
            >
              <i className="fas fa-angle-double-right" />
            </a>
          </li>
        </ul>
      </div>
    </div>
  );
};

export default Pagination;